var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cec-select-search',_vm._b({attrs:{"options":_vm.options,"state":_vm.state,"disabled":_vm.disabled || _vm.loading,"placeholder":_vm.placeholder},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}},'cec-select-search',_vm.$attrs,false))}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b6426a4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/componentes/dropdown/GrupoApagarDropDown.vue
// module id = 1412
// module chunks = 2